import { Validators } from "@angular/forms";
import { FormField } from "./form-field.model";

export const COURSE_FORM: { [key: string]: FormField } = {
    courseId: {
        id: 'courseId',
        type: 'hidden',
        name: 'courseId',
        label: 'ID',
        placeholder: "ID",
        value: 0,
        data: [],
        validators: [],
        errorMessages: {} 
    },
    // Il corso Moodle collegato non è più scelto/modificato da questo form: nasce dal batch di
    // sync e resta fisso. Questi campi restano solo per riportare al backend, invariato, ciò che
    // il corso già aveva (idCourseMoodle è comunque richiesto dal DTO).
    idCourseMoodle: {
        id: 'idCourseMoodle',
        type: 'hidden',
        name: 'idCourseMoodle',
        label: '',
        placeholder: "",
        value: '',
        data: [],
        validators: [],
        errorMessages: {}
    },
    nameCourseMoodle: {
        id: 'nameCourseMoodle',
        type: 'hidden',
        name: 'nameCourseMoodle',
        label: '',
        placeholder: "",
        value: '',
        data: [],
        validators: [],
        errorMessages: {}
    },
    updateIdCourseMoodle: {
        id: 'updateIdCourseMoodle',
        type: 'hidden',
        name: 'updateIdCourseMoodle',
        label: '',
        placeholder: "",
        value: '',
        data: [],
        validators: [],
        errorMessages: {}
    },
    updateNameCourseMoodle: {
        id: 'updateNameCourseMoodle',
        type: 'hidden',
        name: 'updateNameCourseMoodle',
        label: '',
        placeholder: "",
        value: '',
        data: [],
        validators: [],
        errorMessages: {}
    },
    availableTemplatesId: {
        id: 'availableTemplatesId',
        type: 'select',
        name: 'availableTemplatesId',
        label: 'Template Disponibili',
        placeholder: "Seleziona template",
        value: '',
        data: [],
        validators: [Validators.required],
        errorMessages: {
            required: "Selezionare un template."
        }
    },
    riskId: {
        id: 'riskId',
        type: 'select',
        name: 'riskId',
        label: 'Corso Rischio',
        placeholder: "Seleziona corso di rischio",
        value: '',
        data: [],
        validators: [Validators.required],
        errorMessages: {
            required: "Selezionare un corso di rischio."
        }
    },
    // Unico campo editabile legato al nome del corso: sostituisce sia il vecchio "Titolo del
    // Corso" sia la selezione manuale del corso Moodle. Se modificato, il backend prova a
    // propagarlo su Moodle (v. CourseService.updateCourse lato backend).
    title: {
        id: 'title',
        type: 'text',
        name: 'title',
        label: 'Corso Moodle',
        placeholder: "Corso Moodle",
        value: '',
        data: [],
        validators: [Validators.required, Validators.maxLength(100)],
        errorMessages: {
            required: "Inserire il nome del corso.",
            maxlength: "Il nome del corso può contenere al massimo 100 caratteri."
        }
    },
    certificateTitle: {
        id: 'certificateTitle',
        type: 'text',
        name: 'certificateTitle',
        label: 'Titolo del corso sul certificato',
        placeholder: "Titolo Corso Certificato",
        value: '',
        data: [],
        validators: [Validators.required, Validators.maxLength(100)],
        errorMessages: {
            required: "Inserire il titolo del corso sul certificato.",
            maxlength: "Il titolo del corso sul certificato contenere al massimo 100 caratteri."
        }
    },
    legalReference: {
        id: 'legalReference',
        type: 'text',
        name: 'legalReference',
        label: 'Riferimento legge',
        placeholder: "Riferimento Legge",
        value: '',
        data: [],
        validators: [Validators.maxLength(100)],
        errorMessages: {
            maxlength: "Il riferimento legge contenere al massimo 100 caratteri."
        }
    },
    // Niente più campo "Stato" in questo form: isActive si cambia solo dal menu a tendina nella
    // lista corsi (toggle-status), oppure in automatico al completamento di un draft "Da
    // Completare" (v. CourseService.updateCourse lato backend).
    examRequired: {
        id: 'examRequired',
        type: 'single-checkbox',
        name: 'examRequired',
        label: 'Corso Esame Richiesto',
        placeholder: "Corso Esame Richiesto",
        value: false,
        data: [],
        validators: [Validators.required],
        errorMessages: {
            required: "Indicare se l'esame è richiesto."
        }
    },
    duration: {
        id: 'duration',
        type: 'text',
        name: 'duration',
        label: 'Durata Corso ore',
        placeholder: "Durata Corso",
        value: '',
        data: [],
        validators: [Validators.pattern("^[1-9][0-9]*$"), Validators.required],
        errorMessages: {
            required: "Inserire la durata del corso.",
            pattern: "Inserire un numero valido di ore."

        }
    },
    percentage: {
        id: 'percentage',
        type: 'text',
        name: 'percentage',
        label: 'Corso Percentuale',
        placeholder: "Corso Percentuale",
        value: '',
        data: [],
        validators: [Validators.pattern("^[0-9]{1,3}(\\.[0-9]{1,2})?$"), Validators.required],
        errorMessages: {
            required: "Inserire la percentuale del corso.",
            pattern: "Inserire un valore percentuale valido (es. 75 o 75.5)."
        }
    },
    expirationDate: {
        id: 'expirationDate',
        type: 'date',
        name: 'expirationDate',
        label: 'Corso Scadenza',
        placeholder: "Corso Scadenza (se non specificata, il corso non avrà scadenza)",
        value: '',
        data: [],
        validators: [],
        errorMessages: {}
    },
    validityYears: {
        id: 'validityYears',
        type: 'text',
        name: 'validityYears',
        label: 'Corso Validita (anni)',
        placeholder: "Corso Validita Anni",
        value: '',
        data: [],
        validators: [Validators.pattern("^[0-9]+$"), Validators.required],
        errorMessages: {
            required: "Inserire la validita del corso.",
            pattern: "Inserire un numero valido di anni."
        }
    },
};